import { useQuery } from 'react-query';
import { CustomQueryOptions } from '@trukt/types/CustomQueryOptions';
import { queryKeys } from '@trukt/query-keys';
import { useApiContext } from './ApiProvider';

export const useCompanyQuery = (options?: CustomQueryOptions) => {
  const { truktApi } = useApiContext();

  return useQuery({
    queryKey: queryKeys.company.search(),
    queryFn: async () => {
      const response = await truktApi.company.get();
      return response.data;
    },
    staleTime: Infinity,
    cacheTime: Infinity,
    ...options,
  });
};
